import classNamesList from '@apps/AppList/widgets/AppCarousel/styles.module.scss'
import { emptyApplicationsArray } from '@common/constants'
import { useAppSelector, usePrevious } from '@common/hooks'
import AppCard from '@common/widgets/AppCard'
import { EmptyAppList } from '@common/widgets/EmptySections'
import { OneClickButton } from '@common/widgets/OneClickInstallation'
import cx from 'classnames'
import { useRouter } from 'next/router'
import { useMemo, useRef } from 'react'
import Skeleton from 'react-loading-skeleton'

import Pagination from './Pagination'
import classNames from './styles.module.scss'


interface IProps {
  reducer: AppListReducer,
}

export default function ApplicationList({
  reducer,
}: IProps): JSX.Element | null {
  const router = useRouter()
  const applicationList = useAppSelector(store => store[reducer].data?.items || emptyApplicationsArray)
  const applicationReducer = useAppSelector(store => store[reducer].data)
  const isLoading = useAppSelector(store => store[reducer].isLoading)
  const winners = useAppSelector(store => reducer === 'hackathonWinners' ? store.hackathonWinners.winners : null)
  const applicationListOld = usePrevious(applicationList) as IApplication[]

  const wrapperRef = useRef<HTMLDivElement | null>(null)
  const slides = useMemo(() => {
    if(((!applicationReducer && !applicationListOld?.length) || isLoading)) {
      return Array.from({ length: 12 }, (_, index) => (
        <Skeleton className={classNames.skeleton} duration={0.5} key={index}/>
      ))
    }
    const appList = applicationReducer === null ? applicationListOld : applicationList
    const applications = appList.map(
      (app, ind) => {
        let winnerPlace = winners?.findIndex(winner => winner.id === app.id)
        winnerPlace === undefined && (winnerPlace = -1)
        const isWinner = winnerPlace !== -1
        return (
          <AppCard
            {...app}
            application={app}
            className={cx(classNames.card, {
              [classNamesList.shortTitle]: isWinner,
              [classNamesList.borderWinner]: isWinner,
              [classNamesList[`borderWinner${winnerPlace + 1}`]]: isWinner,
            })}
            key={app.id}
            tabIndex={200 + ind}
            dataTest={`${reducer}-card`}
            search={router.query.q as string}
          >
            <OneClickButton app={app} reducer={reducer}/>
            {isWinner && <i className={cx(classNamesList.hackathonWinnersIcon, classNamesList[`winner${winnerPlace + 1}`])} />}
          </AppCard>
        )
      }
    )
    return applications
  }, [applicationList, router.query, isLoading, router.pathname, winners])

  if(!isLoading && applicationList.length === 0 && applicationReducer) {
    return <EmptyAppList reducer={reducer}/>
  }
  return (
    <>
      <div className={classNames.wrapper} ref={wrapperRef}>
        {slides}
      </div>
      {applicationList.length ? <Pagination reducer={reducer}/> : null}
    </>
  )
}
